import axios from "axios";
import store from "@/store";
import { getToken, removeToken, setToken, removetUserType } from "@/utils/auth";
// create an axios instance
const service = axios.create({
  timeout: 50000, // request timeout
});
// request interceptor
service.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    let t = getToken();
    if (t) {
      config.headers["Authorization"] = "bearer " + t;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  function(response) {
    // Do something with response data
    // check if server side vaidation errors exists
    // if(response.data.refreshToken){
    //     setToken(response.data.refreshToken);
    // }
    if (response.data && response.data.statusCode > 200) {
      // send to catch
      var err = { response: { ...response } };
      // return and route response to .catch()
      return Promise.reject(err);
    }
    // else return and route response to .then()
    return response;
  },
  function(error) {
    // Do something with response error
    if (error.response != undefined) {
      if (error.response.status == 401) {
      //  alert("Logout")
      localStorage.clear();
      location.reload()
        // logout();
        // removeToken("Admin-Token");
        // removetUserType();
        // location.href = "/#/login";
        // location.reload();
      }
      if (error.response.status == 403) {
        // window.history.back()
        // $(".overlay-delay").css("display","none");
        // document.getElementsByTagName("body")[0].style.pointerEvents = "";
        // document.getElementsByTagName("html")[0].style.cursor = "";
        location = "./#/unauthorized";
      }
    } else {
      // localStorage.clear();
      // location.href = "/#/login";
      // location.reload();      
    }
    return Promise.reject(error);
  }
);

export default service;
